var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import SessionUtil from 'edge/quoteandbind/common/util/SessionUtil';

var LocationsAndBuildingsCtrl = function () {
    function LocationsAndBuildingsCtrl($state, ModalService, BOPCoverablesService, $stateParams, StateUtils) {
        var _this = this;

        _classCallCheck(this, LocationsAndBuildingsCtrl);

        var $ctrl = this;

        this.model = StateUtils.activeDataForState(true).model;
        this.ModalService = ModalService;
        this.BOPCoverablesService = BOPCoverablesService;

        this.$onInit = function () {
            _this.transactionID = _this.model.quoteID ? _this.model.quoteID.value : _this.model.jobID.value;

            _this.selectedLocationId = $stateParams.locationId;
            _this.selectedBuildingId = $stateParams.buildingId;

            _this.businessOwners = _this.model.lobData.businessOwners;
            _this.locations = _this.businessOwners.coverables.locations.value || [];

            _this.goToLocation = function () {
                return $state.go('location', { initialPage: _this.initialPage });
            };
        };

        this.next = function (nextFn) {
            var checkAllLocationsHaveAtLeastOneBuilding = function checkAllLocationsHaveAtLeastOneBuilding() {
                return $ctrl.locations.filter(function (loc) {
                    return loc.buildings.length === 0;
                }).length === 0;
            };

            if (!checkAllLocationsHaveAtLeastOneBuilding()) {
                var message = 'gw-portals-bop-components-angular.locationsAndBuildings.locationsAndBuildings.locationsAndBuildingsCtrl.Locations are invalid';
                var description = 'gw-portals-bop-components-angular.locationsAndBuildings.locationsAndBuildings.locationsAndBuildingsCtrl.All locations should have at least one building';
                ModalService.showError(message, description);
                nextFn();
            } else {
                nextFn($ctrl.model);
            }
        };
    }

    // Get a function that will remove a location once called


    _createClass(LocationsAndBuildingsCtrl, [{
        key: 'removeLocation',
        value: function removeLocation(location) {
            var _this2 = this;

            return function () {
                _this2.operation = _this2.BOPCoverablesService.removeBOPLocation(_this2.transactionID, location, SessionUtil.getSessionUUID(_this2.model));
                _this2.operation.then(function () {
                    _this2.locations.splice(_this2.locations.indexOf(location), 1);
                }).catch(function () {
                    _this2.ModalService.showError('gw-portals-bop-components-angular.locationsAndBuildings.locationsAndBuildings.locationsAndBuildingsCtrl.Unable to remove location', 'gw-portals-bop-components-angular.locationsAndBuildings.locationsAndBuildings.locationsAndBuildingsCtrl.Please check for errors and try again');
                });
            };
        }
    }]);

    return LocationsAndBuildingsCtrl;
}();

LocationsAndBuildingsCtrl.$inject = ['$state', 'ModalService', 'qnb.bopCoverablesService', '$stateParams', 'StateUtils'];

export default LocationsAndBuildingsCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-bop-components-angular/locationsAndBuildings/locationsAndBuildings/locationsAndBuildingsCtrl.js
// module id = 979
// module chunks = 0